import { createResourceStore } from "@/lib/resource";
import type { Business } from "./Business";

import type { Shop } from "./Shop";

export interface Supplier {
  id: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  region: string;
  country: string;
  business_id: string;
  shop_id: string;
  created_at: string;
  updated_at: string;
  business: Business;
  shop: Shop;
}

export const useSupplier = createResourceStore<Supplier>("suppliers");
